function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import gettext from 'js-utils/gettext';
import Button from '../button/Button';
import * as constants from './constants';

var FollowButton =
/*#__PURE__*/
function (_Component) {
  _inherits(FollowButton, _Component);

  function FollowButton() {
    _classCallCheck(this, FollowButton);

    return _possibleConstructorReturn(this, _getPrototypeOf(FollowButton).apply(this, arguments));
  }

  _createClass(FollowButton, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          onClick = _this$props.onClick,
          isFollowing = _this$props.isFollowing,
          style = _this$props.style,
          size = _this$props.size,
          disabled = _this$props.disabled,
          __containerClassName = _this$props.__containerClassName;
      var buttonText = isFollowing ? gettext('Following') : gettext('Follow');
      var styleClasses = classNames({
        'eds-btn--follow-solitary': style === constants.STYLE_SOLITARY
      });
      var sizeClasses = classNames({
        'eds-btn--follow-compact': size === constants.SIZE_COMPACT,
        'eds-btn--follow-mini': size === constants.SIZE_MINI
      });
      var containerClasses = classNames(styleClasses, sizeClasses, _defineProperty({}, "".concat(__containerClassName), __containerClassName));
      return React.createElement(Button, {
        onClick: onClick,
        disabled: disabled,
        style: "follow",
        isFollowing: isFollowing,
        __containerClassName: containerClasses
      }, buttonText);
    }
  }]);

  return FollowButton;
}(Component);

_defineProperty(FollowButton, "propTypes", {
  /**
  * Disables the button
  */
  disabled: PropTypes.bool,

  /**
   * Following state
   */
  isFollowing: PropTypes.bool,

  /**
   * Callback function invoked when the button is clicked.
   * () => { }
   */
  onClick: PropTypes.func,

  /**
   * Changes the style of the button.
   * Available styles: standard, solitary
   */
  style: PropTypes.oneOf(constants.STYLES),

  /**
   * Changes the size of the button.
   * Available sizes: standard, compact, mini
   */
  size: PropTypes.oneOf(constants.SIZES),

  /**
   * Adds a class name to the container of the button.
   */
  __containerClassName: PropTypes.string
});

_defineProperty(FollowButton, "defaultProps", {
  size: constants.SIZE_STANDARD,
  style: constants.STYLE_STANDARD
});

export { FollowButton as default };